import type { Split } from '../world/Checkpoint';

/** Compare cumulative times from the same checkpoint of the personal-best run. */
export function splitDelta(split: Split, personalBest: readonly Split[]): number | null {
  const best = personalBest.find((candidate) => candidate.id === split.id);
  return best ? split.timeMs - best.timeMs : null;
}
